import React, { useEffect, useState } from 'react';
import HyperLayout from '../components/HyperLayout';
import HeroSection from '../components/HeroSection';
import { Helmet } from 'react-helmet';
import useScrollToTop from '../hooks/useScrollToTop';
import MarkdownRenderer from '../components/MarkdownRenderer';

const MarkdownContent: React.FC = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/docs/terms-and-conditions.md')
      .then(res => res.text())
      .then(setContent);
  }, []);

  return <MarkdownRenderer content={content} />;
};

const TermsAndConditions = () => {
  // Use scroll to top hook
  useScrollToTop();

  return (
    <HyperLayout>
      <Helmet>
        <title>Terms and Conditions | BasedApp</title>
        <meta name="description" content="Read BasedApp's terms and conditions to understand the rules governing our crypto card services, user accounts, fees, risk warnings, and your legal rights." />
        <link rel="canonical" href="https://basedapp.io/terms" />
      </Helmet>
      <HeroSection className="h-[300px]">
        <div className="max-w-screen-xl mt-auto mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-center text-white mb-6">Terms and Conditions</h1>
          <p className="text-xl text-white text-center max-w-3xl mx-auto mb-16">
            Rules governing our crypto card services, user accounts, fees, and your legal rights.
          </p>
        </div>
      </HeroSection>
      <div className="min-h-screen bg-black">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
          <div className="space-y-6 text-white text-sm leading-relaxed">
            <div className="prose prose-sm max-w-none prose-invert prose-headings:text-white prose-headings:font-semibold prose-h2:text-2xl prose-h2:mb-4 prose-p:text-white prose-p:mb-4 prose-li:text-white prose-strong:text-white prose-a:text-primary prose-a:hover:underline">
              <MarkdownContent />
            </div>
          </div>
        </div>
      </div>
    </HyperLayout>
  );
};

export default TermsAndConditions;